export const GATEWAY = 'https://gatewayelb.shayofae.io:8095'
export const DREAMFACTORY = 'https://dfaws.shayofae.io'
